import { Button, useTheme } from "@mui/material";

const verb = (failure) => (failure.action === "disable" ? "turned off" : "enabled");

// Shown after scheduling succeeded but turning the AI on or off didn't. The interview stays scheduled.
export default function AIEnableFailures({ failures, onRetry, retrying }) {
  const theme = useTheme();
  if (!failures.length) return null;

  return (
    <div className="p-3 bg-amber-50 border border-amber-300 text-amber-900 rounded flex flex-col gap-2" role="alert">
      {failures.length === 1 ? (
        <p className="text-sm">
          Interview scheduled, but AI couldn't be {verb(failures[0])}
          {failures[0].label ? ` for ${failures[0].label}` : ""}: {failures[0].message}
        </p>
      ) : (
        <>
          <p className="text-sm font-medium">Interviews scheduled, but AI couldn't be updated for:</p>
          <ul className="list-disc pl-5 text-sm">
            {failures.map((failure) => (
              <li key={failure.interviewId}>
                {failure.label || "Interview"}: {failure.message}
              </li>
            ))}
          </ul>
        </>
      )}
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs">Retry, or close and keep the interview without AI.</p>
        {onRetry && (
          <Button
            onClick={onRetry}
            disabled={retrying}
            sx={{ backgroundColor: theme.palette.info.main, color: theme.palette.text.light, textTransform: "none" }}
          >
            {retrying ? "Retrying..." : "Retry"}
          </Button>
        )}
      </div>
    </div>
  );
}
